/**
 * The Look tab's section on waiting (docs/plans/loading.md): how the page looks while it waits for an answer, each
 * moment with a choice of ways and a preview of the one chosen, the looks, the timing and what a failure shows.
 */
export const loadingLook = {
  section: 'While it waits',
  hint: 'How the page looks while it waits for an answer. A quick answer shows nothing at all; each preview shows what a slow one shows.',
  moments: { first: 'Drawn the first time', refresh: 'Asked again', more: 'The next rows', search: 'A search', action: 'A save or a button' } as Record<string, string>,
  momentHints: {
    first: 'A record, a list or a map as it first comes.',
    refresh: 'A list searched, sorted or paged; a record reloaded.',
    more: 'Rows that come as a list is scrolled; a tree’s children.',
    search: 'A link’s suggestions as people type; a list’s choices.',
    action: 'Save, Send, a button’s steps.',
  } as Record<string, string>,
  ways: {
    skeleton: 'Skeleton',
    spinner: 'Spinner',
    progress: 'Progress bar',
    text: 'Words',
    none: 'Nothing',
    custom: 'The app’s own',
    keep: 'Keep it, a bar over it',
    dim: 'Dim it',
    row: 'A row',
    inline: 'In the list',
    button: 'The button',
    bar: 'A bar along the top',
    overlay: 'Cover the form',
  } as Record<string, string>,
  asDefault: (words: string): string => `${words} (default)`,
  looks: 'Looks',
  skeleton: 'Skeleton',
  skeletons: { shimmer: 'Shimmer', pulse: 'Pulse', static: 'Still' } as Record<string, string>,
  spinner: 'Spinner',
  spinners: { ring: 'Ring', dots: 'Dots' } as Record<string, string>,
  progress: 'Progress bar',
  progresses: { top: 'At the top', inline: 'In the middle' } as Record<string, string>,
  timing: 'Timing',
  delay: 'Wait before showing',
  minShown: 'Show for at least',
  slowAfter: 'Say “Still loading…” after',
  timeout: 'Give up after',
  seconds: 's',
  timingHint: 'In seconds. Give up after, left empty, waits as long as it takes.',
  error: 'When it fails',
  errors: { inline: 'In place', toast: 'Toast', custom: 'The app’s' } as Record<string, string>,
  errorHint: 'Words and Retry in its place, never an empty space.',
  preview: (moment: string): string => `Preview: ${moment}`,
  rows: ['Nile Traders', 'Delta Foods', 'Lotus Clinics'],
  save: 'Save',
  appDraws: 'Drawn by your app',
  changed: 'How the page waits changed',
};
